import { render, staticRenderFns } from "./workerloan-calculator-results.vue?vue&type=template&id=aafa7498&scoped=true&lang=pug"
import script from "./workerloan-calculator-results.vue?vue&type=script&lang=js"
export * from "./workerloan-calculator-results.vue?vue&type=script&lang=js"
import style0 from "./workerloan-calculator-results.vue?vue&type=style&index=0&id=aafa7498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafa7498",
  null
  
)

export default component.exports